<template>
  <SideModal
    :show="show"
    @update:show="
      {
        if (!state.loadingSave) $emit('update:show', $event);
      }
    "
    location="left"
    close-on-overlay-click
  >
    <div class="modal-container">
      <div class="modal-top">
        <Typography color="primary" weight="600" size="1.25rem">Add Team</Typography>
        <v-btn
          @click="
            {
              if (!state.loadingSave) $emit('update:show', false);
            }
          "
          variant="plain"
          color="normal"
          icon
          ><v-icon color="gray600">mdi-close</v-icon></v-btn
        >
      </div>

      <form @submit.prevent="save" class="modal-body">
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="Team Name"
            v-model="state.team_name"
          ></v-text-field>
          <FormValidate
            :validate="state.team_name"
            :regex="/.{1,50}/"
            title="Team Name must have length of 1 - 50 characters"
          ></FormValidate>
        </div>
        <div>
          <v-btn
            width="100%"
            type="submit"
            :loading="state.loadingSave"
            style="text-transform: capitalize"
            >Save</v-btn
          >
        </div>
      </form>
    </div>
  </SideModal>
</template>

<script setup lang="ts">
import SideModal from "@/components/sideModal.vue";
import Typography from "@/components/typography.vue";
import { watch } from "vue";
import { reactive } from "vue";
import { useAlertsStore } from "@/stores/alerts";
import useTeams from "@/stores/school/teams";
import FormValidate from "@/components/formValidate.vue";

const props = defineProps<{
  show: boolean;
}>();

const state = reactive({
  loadingSave: false,
  team_name: ""
});

const teamsS = useTeams();

watch([() => props.show], () => {
  Object.assign(state, {
    loadingSave: false,
    team_name: ""
  });
});

const emit = defineEmits<{
  (e: 'update:show', ...args: any[]): void;
  (e: 'update:search', ...args: any[]): void
}>();

const save = async () => {
  // save Team
  state.loadingSave = true;

  const res = await teamsS.createTeam({
    team_name: state.team_name
  });

  useAlertsStore().addAlert(
    res ? "success" : "error",
    res ? "Team Name updated successfully" : "Failed to update team data",
    5
  );
  if (res) emit("update:search", res);
  state.loadingSave = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.modal-container {
  padding: 30px;

  .modal-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 30px;
  }
}
</style>
